import { createTranslationsPageProvider } from '@edreamsodigeo/frontend-core';
export const TranslationsPageProvider = createTranslationsPageProvider({
  userAuthentication: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "[request]" */`@edreamsodigeo/frontend-user-authentication/translations/${brand}/${locale}/magic_link_user_authenticator.js`)
});